import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon } from '@repo/icons';
import classNames from 'classnames';
import { useId } from 'react';
const checkboxStyles = {
    base: 'h-4 w-4 shrink-0 rounded outline outline-1 flex items-center justify-center transition-colors',
    interactive: 'cursor-pointer',
    default: 'bg-secondary-strong outline-stroke-base-strong',
    checked: 'bg-brand outline-stroke-brand',
    disabled: 'cursor-not-allowed opacity-60',
};
const labelStyles = {
    base: 'text-heading text-sm leading-4 font-medium',
};
export default function Checkbox({ checked = false, className, disabled = false, label, onChange, testId, ...inputProps }) {
    const inputId = useId();
    const checkboxClasses = classNames(checkboxStyles.base, !disabled && checkboxStyles.interactive, checked ? checkboxStyles.checked : checkboxStyles.default, disabled && checkboxStyles.disabled);
    const handleChange = () => {
        if (disabled)
            return;
        onChange?.(!checked);
    };
    return (_jsxs("label", { className: classNames('inline-flex items-start justify-start gap-2.5 select-none', !disabled && 'cursor-pointer', className), htmlFor: inputId, "data-testid": testId, children: [_jsx("input", { id: inputId, type: "checkbox", checked: checked, disabled: disabled, onChange: handleChange, className: "hidden", "data-testid": testId.append('input'), ...inputProps }), _jsx("div", { className: checkboxClasses, "aria-hidden": true, children: checked && _jsx(CheckIcon, { size: 16, className: "text-white" }) }), label && (_jsx("div", { className: "flex items-center justify-start gap-2.5", children: _jsx("div", { className: labelStyles.base, children: label }) }))] }));
}
